import { useContext } from 'react';
import { RealTimeContext } from '../context/RealTimeContext';
/**
 * Custom hook that provides access to the RealTime context.
 * Must be used within a RealTimeProvider component.
 * @throws If used outside of a RealTimeProvider
 * @returns The RealTime context value
 * @public
 */
export const useRealTimeContext = () => {
  const context = useContext(RealTimeContext);
  if (!context) {
    throw new Error('useRealTimeContext must be used within a RealTimeProvider');
  }
  return context;
};